import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { useBillingGate } from '../hooks/useBillingGate';

/**
 * Read-only paywall notice (hueco D1). Shown whenever the org's subscription is
 * inactive, so writes are gated server-side. Admins get a CTA to reactivate;
 * operators are told to contact their admin (they can't manage billing). Takes
 * precedence over BillingStatusBanner, which bails while this is up.
 */
export const BillingGateBanner = () => {
  const { t } = useTranslation('common');
  const { lng = 'es' } = useParams();
  const { isReadOnly, isBillingAdmin } = useBillingGate();

  if (!isReadOnly) {
    return null;
  }

  return (
    <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
      <Lock className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-medium">{t('billing.gate.readOnly.title')}</p>
        {isBillingAdmin ? (
          <p className="mt-0.5">
            {t('billing.gate.readOnly.adminBody')}{' '}
            <Link to={`/${lng}/billing`} className="font-semibold underline underline-offset-2">
              {t('billing.gate.readOnly.adminCta')}
            </Link>
          </p>
        ) : (
          <p className="mt-0.5">{t('billing.gate.readOnly.operatorBody')}</p>
        )}
      </div>
    </div>
  );
};
